import newPrimary, { newPrimaryPx } from './new-primary';
import primary, { primaryPx } from './primary';

const themes = {
  primary,
  primaryPx,
  newPrimary,
  newPrimaryPx,
};

export default themes;
